import React, { Component } from "react";
import IOrder from "../../../../../models/IOrder";
import IOrder_Item from "../../../../../models/IOrder_Item";
import IOwTableCols from "../../../../../models/IOwTableCols";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import OrderStatesEnum from "../../../../../models/OrderStatesEnum";
import UserService from "../../../../../services/UserService";
import AddressDisplay from "../../../../shared/AddressDisplay/AddressDisplay";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwTable from "../../../../shared/OwTable/OwTable";
import * as _ from "lodash-es";

type Props = {
    order: IOrder;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
};

type State = {
    columns: IOwTableCols[];
};

class OrdersDetailReportOrderRow extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            columns: [
                {
                    title: "no",
                    valueProp: "item_no",
                },
                {
                    title: "sku",
                    valueProp: "Catalog_Item",
                    valueSubProp: "sku",
                },
                {
                    title: "description",
                    valueProp: "Catalog_Item",
                    valueSubProp: "description",
                },
                {
                    title: "category",
                    valueProp: "",
                    renderFn: this.renderCategoryFn,
                    renderFnEmitsRow: true,
                },
                {
                    title: "order_qty",
                    valueProp: "qty",
                },
            ],
        };
    }

    renderCategoryFn = (row: IOrder_Item) => {
        return row?.Catalog_Item?.Category ? row?.Catalog_Item?.Category?.name : null;
    };

    processDate = (dateStr: string) => {
        if (!dateStr.length) {
            return null;
        }

        return UserService.parseDate(dateStr);
    };

    getOrderState = () => {
        const state = this.props.order.order_state_id;

        switch (state) {
            case OrderStatesEnum.CONFIRMED:
                return "Confirmed";
        }

        return _.startCase((this.props.order?.Order_State?.name || "").toLowerCase());
    };

    render() {
        return (
            <div className="OrdersDetailReportOrderRow mb-5">
                <div className={"row border m-1 p-1"}>
                    <div className={"col-3"}>
                        <OwLabel className={"me-2"} title={"order"} noBottomMargin={true} isBold={true} />
                        {this.props.order.name}
                    </div>
                    <div className={"col-3"}>
                        <OwLabel className={"me-2"} title={"status"} noBottomMargin={true} isBold={true} />
                        {this.getOrderState()}
                    </div>
                    <div className={"col-3"}>
                        <OwLabel className={"me-2"} title={"created_at"} noBottomMargin={true} isBold={true} />
                        {this.processDate(this.props.order.created_at)}
                    </div>
                    <div className={"col-3"}>
                        <OwLabel className={"me-2"} title={"submitted_at"} noBottomMargin={true} isBold={true} />
                        {this.processDate(this.props.order.submit_date || "")}
                    </div>
                </div>

                <div className={"row mt-2 p-2"}>
                    <div className={"col-12"}>
                        <OwLabel title={"created_by"} className={"me-2"} noBottomMargin={true} isBold={true} />
                        <span className={"me-2"}>{this.props.order?.User?.name}</span>
                        <span>{this.props.order?.User?.email}</span>
                    </div>
                </div>

                <div className={"mt-4 mb-4 border d-inline-flex flex-column p-2"}>
                    <div className={"border-bottom pb-2 mb-2"}>
                        <OwLabel
                            className={"me-2"}
                            isBold={true}
                            noBottomMargin={true}
                            title={"vendor"}
                            supplierModel={this.props.supplierModel}
                            isSupplierVendorOverride={true}
                        />
                        {this.props.order?.Vendor?.name}
                    </div>
                    <div>
                        <OwLabel isBold={true} noBottomMargin={true} title={"ship_to"} />
                        <div className={"ms-4"}>
                            <AddressDisplay address={this.props.order.Ship_To || this.props.order?.Vendor?.Ship_To} />
                        </div>
                    </div>
                </div>

                <div>
                    <OwTable
                        columns={this.state.columns}
                        dataSet={this.props.order.Order_Items || []}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={false}
                        initialData={false}
                    />
                </div>

                <hr />
            </div>
        );
    }
}

export default OrdersDetailReportOrderRow;
